module.exports = __webpack_public_path__ + "static/img/wmp669.c093f22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wmp669.jpg
// module id = Fp5t
// module chunks = 0